import {
  QuestionMetadataDto,
  UpsertQuestionMetadataDto,
} from '@keyops-cep/api-client';

import { apiClient } from './swagger-codegen-api-config';

export const upsertQuestionMetadata = async (
  newQuestionMetadata: UpsertQuestionMetadataDto
): Promise<QuestionMetadataDto> => {
  try {
    const res =
      await apiClient.questionsMetadataApi.questionMetadataControllerUpsertOne(
        newQuestionMetadata
      );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
